import React from 'react'
import Page from '../Page'

const HighDI = ({ testResult }) => {
  return (
    <>
      <Page
        testResult={testResult}
        title="معرفی الگوی رفتاری High DI تسلط + اثرگذاری"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی  High DI ترکیبی از جسارت، صراحت، و تأثیرگذاری بالا هستند. این افراد دارای انرژی زیاد، کلام نافذ، شخصیت قوی و اعتماد به‌نفس بالا می‌باشند. آن‌ها اهل رقابت، هدف‌گرا، خوش‌بیان و سریع‌العمل‌اند. اگر موقعیتی برای رهبری، حل مسئله، یا جلب توجه وجود داشته باشد، معمولاً پیش‌قدم می‌شوند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="معرفی الگوی رفتاری High DI تسلط + اثرگذاری"
      >
        <p className="text-gray-800 leading-7">
          High DI  ها می‌خواهند هم تأثیرگذار باشند و هم نتیجه بگیرند. آن‌ها انگیزه دارند دیگران را به حرکت وادار کنند، الهام ببخشند و در عین حال مسیر و کنترل امور را در دست داشته باشند. اگر دیگران همکاری نکنند یا عملکرد ضعیفی داشته باشند، ممکن است این افراد صبور نباشند و واکنش تند نشان دهند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های کلیدی افراد High DI :"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>به سرعت تصمیم می‌گیرند و عمل می‌کنند.</li>
          <li>توانایی زیادی در متقاعد کردن دیگران دارند.</li>
          <li>دوست دارند دیده شوند، تأثیر بگذارند و محبوب باشند.</li>
          <li>به شدت دنبال نتیجه هستند؛ نتیجه برایشان مهم‌تر از مسیر است.</li>
          <li>کمتر به جزئیات توجه دارند و درگیر کلیات و اهداف بزرگ‌اند.</li>
          <li>به دلیل اعتماد به نفس بالا، گاهی ممکن است شتاب‌زده یا ریسک‌پذیر عمل کنند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قوت High DI :"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>پرانرژی و الهام‌بخش</li>
          <li>مهارت ارتباطی بالا</li>
          <li>رهبری طبیعی</li>
          <li>قدرت در حل مسائل چالشی و پیشبرد اهداف بزرگ</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قابل بهبود:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>توجه بیشتر به جزئیات و فرآیند</li>
          <li>کنترل هیجانات و کاهش پرخاشگری</li>
          <li>گوش دادن فعال‌تر و افزایش صبر</li>
          <li>مشورت با افراد تحلیل‌گر برای تصمیم‌گیری دقیق‌تر</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قابل بهبود:"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فرض کنید فرد  High DI مسئول راه‌اندازی یک کمپین فروش است. او با انرژی وارد می‌شود، تیم را تشویق می‌کند، شعار طراحی می‌کند، جلسات را پرشور برگزار می‌کند و تیم را به حرکت وامی‌دارد. اما اگر اعضای تیم کند عمل کنند یا فرآیندها بیش از حد پیچیده باشد، ممکن است به‌جای اصلاح مسیر، بر تیم فشار بیاورد یا کارها را خودش به دست بگیرد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          The Wolf of Wall Street  شخصیت جردن بلفورت، با بیانی قوی، انرژی بالا، قدرت تأثیرگذاری فوق‌العاده و تمایل شدید به نتایج و فروش، یک نمونه جذاب و البته هشداردهنده از  High DI است. (با تأکید بر ضرورت تعدیل و اخلاق‌مداری)
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری الگوی High DI"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی  High DI ترکیبی از ویژگی‌های تیپ D  تسلط و تیپ I  اثرگذاری را دارند؛ این یعنی آن‌ها نه‌تنها دوست دارند بر شرایط و افراد مسلط باشند، بلکه می‌خواهند تأثیرگذار، محبوب، و الهام‌بخش هم باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. قدرت نفوذ بالا</h3>
        <p className="text-gray-800 leading-7">
          High DIها در تعامل با دیگران قدرت متقاعدسازی فوق‌العاده‌ای دارند. می‌توانند با زبان بدنی قدرتمند، صدای رسا، و کلمات انگیزشی دیگران را همراه کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تمایل به نتیجه همراه با دیده شدن</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها می‌خواهند پیروز شوند و دیگران هم ببینند که آن‌ها پیروز شده‌اند. برند شخصی، دیده شدن، و موفقیت هم‌زمان برایشان اهمیت دارد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. سرعت بالا در فکر و اجرا</h3>
        <p className="text-gray-800 leading-7">
          High Di ها به‌دلیل انرژی زیاد، از کندی، تعلل یا بحث‌های طولانی خسته می‌شوند. آن‌ها افراد «عمل‌گرا» هستند و گاهی قبل از فکر کردن، تصمیم می‌گیرند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. رقابتی، چالش‌دوست، و گاه بی‌قرار</h3>
        <p className="text-gray-800 leading-7">
          موقعیت‌های پرتنش و رقابتی آن‌ها را به وجد می‌آورد. در محیط‌های باثبات و تکراری، ممکن است بی‌حوصله یا بی‌انگیزه شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. نادیده گرفتن جزئیات و عجله در تصمیم‌ها</h3>
        <p className="text-gray-800 leading-7">
          به‌دلیل تمایل به حرکت سریع و کلان‌نگری، ممکن است به نکات ظریف توجه نکنند یا بدون بررسی عمیق تصمیم بگیرند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری الگوی High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. اعتماد به نفس بالا، اما گاهی بدون خودنظارتی</h3>
        <p className="text-gray-800 leading-7">
          این افراد معمولاً از خود مطمئن‌اند. اما اگر خودآگاهی‌شان رشد نکند، ممکن است دچار خودمحوری، قضاوت زودهنگام یا حتی غرور شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. کاریزماتیک اما گاهی کنترل‌گر</h3>
        <p className="text-gray-800 leading-7">
          High DI ها اگر تعدیل نشوند، ممکن است دیگران را نادیده بگیرند یا حتی در تعامل، حالت تهاجمی پیدا کنند. آن‌ها باید بین «رهبری» و «سلطه‌گری» تفاوت قائل شوند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          در یک جلسه فروش، فرد  High DI وارد می‌شود، پرانرژی، با طنز و شور زیاد حرف می‌زند، تیم را به حرکت وامی‌دارد و مشتری را با شور و شوق متقاعد می‌کند. اما اگر مشتری شک داشته باشد یا کند تصمیم بگیرد، ممکن است کلافه شده یا رفتار تند از او سر بزند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تشریح الگوی رفتاری High DI"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ  High DI نه‌تنها به دستیابی به اهداف بزرگ علاقه‌مندند، بلکه می‌خواهند دیگران نیز آن‌ها را ببینند، تأیید کنند، و تحت تأثیر عملکردشان قرار بگیرند. آن‌ها انگیزه اصلی‌شان را از ترکیب «قدرت» و «تأثیرگذاری اجتماعی» می‌گیرند. این ترکیب باعث می‌شود در بسیاری از موقعیت‌های کاری و اجتماعی در خط مقدم دیده شوند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="انگیزه شما در تیپ High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. پیشرفت سریع و بردهای بزرگ</h3>
        <p className="text-gray-800 leading-7">
          High DI ها می‌خواهند در کوتاه‌ترین زمان، بیشترین موفقیت را کسب کنند. دستیابی به جایگاه‌های رهبری، پاداش‌های بزرگ، و بردهای رقابتی برای آن‌ها بسیار محرک است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دیده شدن، مورد توجه بودن و اثرگذاری</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها دوست دارند در کانون توجه باشند؛ در جلسات بدرخشند، در جمع صحبت کنند، و اثرگذار به نظر برسند. انرژی مثبت اطرافیان و تشویق شدن به‌طرز چشمگیری عملکردشان را بالا می‌برد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تسلط بر شرایط و رهبری جمع</h3>
        <p className="text-gray-800 leading-7">
          این تیپ ترجیح می‌دهد کنترل امور را در دست بگیرد. اگر محیطی فاقد رهبری یا جهت مشخص باشد، خودشان داوطلب می‌شوند که آن را هدایت کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. رقابت و چالش</h3>
        <p className="text-gray-800 leading-7">
          High DIها در موقعیت‌هایی که باید رقابت کنند یا چالش جدی‌ای را پشت سر بگذارند، بهترین عملکرد را دارند. آن‌ها از فرصت‌هایی که نیاز به جسارت، بیان قوی، و سرعت دارند، لذت می‌برند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. آزادی عمل و استقلال در تصمیم‌گیری</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها به شدت از کنترل شدن، ریزبینی بیش‌ازحد دیگران، یا ورود به حریم تصمیم‌گیری‌شان ناراحت می‌شوند. انگیزه‌شان در محیط‌هایی که آزادی دارند چند برابر می‌شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رفتار بیرونی High DI چگونه به‌نظر می‌رسد؟"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>پُرانرژی، پرشور، و سریع‌العمل</li>
          <li>دارای حس رهبری ذاتی</li>
          <li>اهل نمایش مثبت عملکرد</li>
          <li>به‌ظاهر جسور، ولی گاهی ناپایدار در پیگیری عمق موضوع</li>
          <li>در تعاملات، از شوخی، زبان بدن، و بیان پرحرارت استفاده می‌کنند</li>
        </ul>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فرد  High DI که مدیر یک استارتاپ است، برای جذب سرمایه‌گذار با اعتماد به نفس بالا، پرزنت جذابی ارائه می‌دهد، با شور فراوان صحبت می‌کند، و تیم را پشت خود جمع می‌کند. اما اگر جلسه زیاد فنی یا طولانی شود، ممکن است تمرکزش را از دست بدهد یا به تیم فنی فشار بیاورد تا زودتر به نتیجه برسند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "Steve Jobs" (2015) –  در این فیلم شخصیت استیو جابز به‌عنوان فردی با ویژگی‌های  High DI نمایش داده می‌شود: پرشور، الهام‌بخش، اما در عین حال چالش‌برانگیز برای تیم به‌دلیل توقع زیاد و سرعت بالا.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          عمل‌گرا، سریع، الهام‌بخش... اما گاهی شتاب‌زده و سطحی
          افراد با الگوی  High DI در محیط‌های کاری معمولاً انرژی زیادی دارند، به‌سرعت وارد عمل می‌شوند، و روحیه‌ای رقابتی و نتیجه‌گرا دارند. آن‌ها عادت دارند محیط اطراف خود را به حرکت درآورند، دیگران را به اقدام تشویق کنند و کار را جلو ببرند — حتی اگر جزئیات را به‌طور کامل نشناسند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. شروع‌کننده قوی، ادامه‌دهنده متوسط</h3>
        <p className="text-gray-800 leading-7">
          High DIها برای شروع پروژه‌ها انگیزه زیادی دارند. اما اگر فرآیند طولانی شود یا با مانع فنی یا جزیی برخورد کنند، ممکن است علاقه‌شان را از دست بدهند یا آن را به دیگران واگذار کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. نتیجه‌گرا، نه فرآیندمحور</h3>
        <p className="text-gray-800 leading-7">
          مسیر و روش کار اگر طولانی، کند یا بیش‌ازحد دقیق باشد، برای آن‌ها خسته‌کننده است. آن‌ها تمرکزشان را بر «نتیجه سریع» می‌گذارند و گاهی از روند صحیح فاصله می‌گیرند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. چندکاره و پرشتاب</h3>
        <p className="text-gray-800 leading-7">
          این افراد معمولاً چند پروژه را به‌طور هم‌زمان مدیریت می‌کنند. اما در اثر این پرکاری، ممکن است دچار پراکندگی شوند و تمرکز لازم را از دست بدهند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تسلط‌گرا در تیم</h3>
        <p className="text-gray-800 leading-7">
          در کار تیمی، دوست دارند تصمیم‌گیرنده یا لیدر باشند. اگر ازشان خواسته شود فقط اجرا کنند، ممکن است انگیزه‌شان کاهش پیدا کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. خوش‌بیان و کلامی قوی در جلسات</h3>
        <p className="text-gray-800 leading-7">
          در ارائه، متقاعدسازی و سخنرانی قوی‌اند. آن‌ها در جلسات کاری معمولاً بیش از دیگران صحبت می‌کنند و توانایی جذب نظر تیم را دارند
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. ساختارگریز، انعطاف‌پذیر و ریسک‌پذیر</h3>
        <p className="text-gray-800 leading-7">
          از سیستم‌های بسیار سخت‌گیرانه، بروکراسی پیچیده، و قوانین خشک فراری‌اند. ترجیح می‌دهند فضا باز و انعطاف‌پذیر باشد تا ایده‌هایشان را پیاده کنند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          در پروژه راه‌اندازی کمپین فروش، فرد  High DI فوراً تیم‌سازی می‌کند، انرژی بالا ایجاد می‌کند، به سراغ مشتریان بالقوه می‌رود و هیجان کار را بالا می‌برد. اما ممکن است برنامه‌ریزی دقیق یا بررسی فنی جزئیات را به‌کلی به تأخیر بیندازد.
          هشدار: اگر  High DI ها یاد نگیرند کارها را به پایان برسانند، ممکن است فقط آغازگر باشند و پروژه‌ها نیمه‌کاره بمانند. همچنین اگر یاد نگیرند بازخورد فنی را بشنوند، ممکن است در مسیر اشتباه پافشاری کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های افراد در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          ترکیبی از جاه‌طلبی، نفوذ، و نگاه رو به جلو
           High DI ها جهان را به عنوان عرصه‌ای برای رقابت، تأثیرگذاری و خلق موفقیت می‌بینند. نگاه‌شان آینده‌محور، پیش‌برنده، و گاه بلندپروازانه است. آن‌ها تمایل دارند در مرکز تصمیم‌گیری، دیده شدن و جریان‌های اثرگذار باشند و فرصت‌ها را زودتر از دیگران شکار کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. دیدگاه به خود:</h3>
        <p className="text-gray-800 leading-7">
          خود را فردی با توان رهبری، اثرگذاری و لیاقت بالا برای موفقیت می‌دانند.
          اعتماد به نفس‌شان معمولاً زیاد است و دوست دارند الگو باشند.
          گاهی این اعتماد به نفس زیاد می‌تواند مانع از شنیدن بازخورد شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دیدگاه به دیگران:</h3>
        <p className="text-gray-800 leading-7">
          نسبت به افراد کند، بیش‌ازحد محتاط یا منفی‌نگر صبور نیستند.
          از اطرافیان انتظار دارند پرانرژی، سریع و نتیجه‌گرا باشند.
          اگر کسی پیرو آن‌ها نباشد یا از نظرشان عقب بماند، ممکن است او را حذف کنند یا نادیده بگیرند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. دیدگاه به کار و موفقیت:</h3>
        <p className="text-gray-800 leading-7">
          کار را عرصه‌ای برای اثبات خود می‌دانند.
          موفقیت برای آن‌ها نه‌فقط رسیدن به هدف، بلکه نمایش رسیدن به هدف است.
          تلاش می‌کنند رهبر تیم، سخنگو یا چهره دیده‌شده در پروژه باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. دیدگاه به اشتباه و بازخورد:</h3>
        <p className="text-gray-800 leading-7">
          ممکن است اشتباهات را نپذیرند یا توجیه کنند، مگر اینکه با مهارت به آن‌ها بازخورد داده شود.
          اگر اشتباه را بپذیرند، برای اصلاح سریع عمل می‌کنند و حتی اشتباه را به فرصت تبدیل می‌کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. دیدگاه به آینده:</h3>
        <p className="text-gray-800 leading-7">
          آینده برای آن‌ها فرصتی برای رشد، قدرت و گسترش نفوذ است.
          دید استراتژیک دارند، اما نه لزوماً تحلیل‌محور؛ بیشتر به «جذب» و «حرکت» اهمیت می‌دهند تا جزئیات.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های افراد در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          در یک سازمان، فرد  High DI ممکن است پروژه‌ای را فقط به شرطی بپذیرد که بتواند آن را «برند» کند. اگر احساس کند قرار نیست دیده شود یا تأثیرگذار باشد، ممکن است آن پروژه را ترک کند، حتی اگر به موفقیت نزدیک باشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          Moneyball شخصیتی مانند بیلی بین، با انرژی بالا، تصمیم‌گیری سریع، و تأثیرگذاری رسانه‌ای. اگرچه تصمیم‌های او با جسارت همراه است، اما گاهی از دید فنی تیم عقب می‌ماند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          سرگرمی‌هایی پرانرژی، اجتماعی، پرهیجان و مبتنی بر رقابت

          High DI ها در اوقات فراغت نیز مانند محیط کاری، دنبال شور، تحرک، دیده شدن و برنده شدن هستند. آن‌ها آرام نمی‌نشینند و تمایلی به فعالیت‌های یکنواخت یا تنهایی ندارند. اگر فرصتی برای رقابت، نمایش مهارت، یا ارتباط با دیگران باشد، آن فعالیت برایشان جذاب‌تر است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. علاقه به فعالیت‌های پرانرژی و رقابتی</h3>
        <p className="text-gray-800 leading-7">
          ورزش‌های گروهی، بازی‌های هیجانی (مثل پینت‌بال یا اتاق فرار)، مسابقات یا حتی بازی‌های رومیزی رقابتی، جزو انتخاب‌های محبوب High DIهاست.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. حضور در جمع‌های پرجنب‌وجوش</h3>
        <p className="text-gray-800 leading-7">
          High DIها ترجیح می‌دهند در دورهمی‌های اجتماعی، رویدادهای انگیزشی، جشن‌ها یا فضاهایی که بتوانند بدرخشند و ارتباطات جدید بسازند، حضور داشته باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. رهبری تفریح نیز برایشان مهم است</h3>
        <p className="text-gray-800 leading-7">
          حتی در تفریح، دوست دارند تصمیم‌گیرنده یا برنامه‌ریز باشند. مثلاً: «کجا بریم؟ کی بریم؟ کی دعوت بشه؟» را خودشان تعیین کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. دوری از فراغت‌های تکراری یا بی‌هیجان</h3>
        <p className="text-gray-800 leading-7">
          فعالیت‌هایی مثل تماشای طولانی‌مدت فیلم‌های آرام، مطالعه انفرادی یا وقت‌گذرانی بی‌هدف برای آن‌ها خسته‌کننده است، مگر اینکه عنصر تعامل یا سرعت در آن باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تمایل به یادگیری از طریق تجربه و تعامل</h3>
        <p className="text-gray-800 leading-7">
          در تعطیلات یا سفر، دنبال تجربه‌های جدید، چالش‌های تازه یا ارتباط با آدم‌های جدیدند ، نه صرفاً استراحت و دراز کشیدن.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          High DI در سفر به‌جای دراز کشیدن کنار ساحل، ترجیح می‌دهد مسابقه طناب‌کشی راه بیندازد، در گشت شهری راهنما شود یا افراد جدیدی را برای ارتباط و تعامل پیدا کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          Yes Man مرد بله گو،  اگرچه شخصیت اول در ابتدا منفعل است، اما با پذیرش چالش‌ها و تعاملات اجتماعی وارد دنیایی پرتحرک و انسانی می‌شود؛ نمایی از دنیایی که  High DI ها آن را به‌صورت طبیعی زندگی می‌کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تصمیم‌گیری در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          High DI ها در تصمیم‌گیری معمولاً سریع، شهودی، جسور و مبتکرند. آن‌ها از تصمیم‌های بزرگ یا ریسک‌پذیر نمی‌ترسند و ترجیح می‌دهند سریع عمل کنند تا اینکه وقت زیادی برای بررسی بگذارند. اگرچه این سبک در برخی موقعیت‌ها مزیت است، اما اگر تعدیل نشود، می‌تواند منجر به اشتباهات بزرگ یا تصمیم‌های عجولانه شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. سرعت بالا، گاهی بدون عمق کافی</h3>
        <p className="text-gray-800 leading-7">
          در لحظه تصمیم می‌گیرند، به ندرت از دیگران نظر می‌خواهند و ترجیح می‌دهند ابتدا اقدام کنند، سپس اصلاح. این ویژگی در شرایط بحرانی خوب است، اما در موضوعات پیچیده می‌تواند آسیب‌زا باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. بیشتر به شهود و حس درونی تکیه می‌کنند تا تحلیل منطقی</h3>
        <p className="text-gray-800 leading-7">
          برای آن‌ها انرژی، انگیزه و حس "درست بودن تصمیم" از منطق و تحلیل جلوتر است. ممکن است جزئیات مهم نادیده گرفته شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. ممکن است از مشورت فرار کنند</h3>
        <p className="text-gray-800 leading-7">
          چون دوست ندارند نظرشان زیر سؤال برود یا کسی جلوی تصمیم‌شان بایستد. به‌خصوص اگر طرف مقابل خیلی منطقی، کند یا محتاط باشد مثل تیپ C  یا S
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تصمیم‌گیری تحت هیجان یا عصبانیت</h3>
        <p className="text-gray-800 leading-7">
          گاهی در اوج انگیزه یا حتی خشم، تصمیم‌های مهمی می‌گیرند که بعداً پشیمانی می‌آورد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاداتی برای بهبود فرآیند تصمیم‌گیری"
      >
        <p className="text-gray-800 leading-7">
          ✅ قبل از تصمیم، از خودت ۳ سوال بپرس:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>اگر شکست بخورم، چه تبعاتی دارد؟</li>
          <li>آیا داده کافی برای این تصمیم دارم؟</li>
          <li>چه کسی می‌تواند دیدگاه متفاوتی بدهد؟</li>
        </ul>
        <p className="text-gray-800 leading-7">
          ✅ با افراد High C یا CS مشورت کن
          آن‌ها کندتر، جزئی‌نگرتر و تحلیل‌محورترند. دید آن‌ها می‌تواند مکمل شهود و سرعت تو باشد.
        </p>
        <p className="text-gray-800 leading-7">
          ✅ هنگام عصبانیت یا هیجان بالا، تصمیم نگیر، اگر احساسی شدی، فقط بنویس، فکر کن، اما اقدام نکن تا آرام شوی.
        </p>
        <p className="text-gray-800 leading-7">
          ✅ تفاوت بین «حرکت سریع» و «تصمیم شتاب‌زده» را بشناس، هر تصمیم سریع، الزاماً مؤثر نیست. تمرین «تأمل با برنامه» یاد بگیر.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاداتی برای بهبود فرآیند تصمیم‌گیری"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فرد  High DI می‌خواهد فوراً یک نمایندگی جدید راه بیندازد چون حس می‌کند «فرصت خوبی است»؛ بدون بررسی دقیق بازار، سرمایه لازم یا مشورت با واحد مالی. اگر یاد بگیرد فقط ۲ روز تأمل و تحلیل کند، احتمال موفقیتش چند برابر می‌شود.
        </p>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی:
           The Social Network  شخصیت مارک زاکربرگِ فیلم، از تصمیم‌گیرندگان سریع و اثرگذار است، اما تضادش با افراد منطقی و محتاط‌تر مثل شریکش، نمونه‌ای از چالش تصمیم‌گیری‌های تیپ  HIGH DI  است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد High DI"
      >
        <p className="text-gray-800 leading-7">
          پیشنهادات کاربردی جهت بهبود عملکرد افراد با الگوی High DI
          افراد  High DI ظرفیت بالایی برای موفقیت، اثرگذاری، رهبری و پیشرفت سریع دارند. اما برای اینکه به‌جای «سوختن» در مسیر پرانرژی خود، «بسوزانند و روشن کنند»، نیاز به تعدیل برخی رفتارها و تقویت مهارت‌های خاص دارند. در ادامه، پیشنهادهایی برای افزایش اثربخشی، کاهش فرسودگی و بهبود تعاملات انسانی این تیپ آورده شده است:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. مهارت گوش دادن فعال را تمرین کن</h3>
        <p className="text-gray-800 leading-7">
          High DI ها بیشتر گوینده‌اند تا شنونده. اگر یاد بگیرند بدون قطع کردن و قضاوت، به‌طور کامل حرف طرف مقابل را بشنوند، روابط عمیق‌تر و تصمیمات بهتری خواهند داشت.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. به دیگران هم فرصت درخشیدن بده</h3>
        <p className="text-gray-800 leading-7">
          تمایل به دیده شدن و رهبری ممکن است باعث شود دیگران را در سایه قرار دهند. گاهی اجازه بدهند تیم جلو بیفتد و خودشان پشتیبان باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تمرین کن قبل از «انجام»، «اندیشه» داشته باشی</h3>
        <p className="text-gray-800 leading-7">
          بین انگیزه و اقدام، چند دقیقه تأمل، برنامه‌ریزی یا مشورت می‌تواند بسیار مؤثر باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. جزئیات را نادیده نگیر</h3>
        <p className="text-gray-800 leading-7">
          همکاری با افراد دقیق، استفاده از چک‌لیست، یا بازبینی نهایی تصمیمات، به کاهش خطاهای عجولانه کمک می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. قاطعیت را با مهربانی همراه کن</h3>
        <p className="text-gray-800 leading-7">
          تفاوت بزرگی است بین «اثرگذاری» و «تسلط افراطی». تمرین همدلی و بیان صریح ولی محترمانه، به حفظ روابط کمک می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. به پایان رساندن پروژه‌ها را اولویت بده</h3>
        <p className="text-gray-800 leading-7">
          شروع‌های خوب نقطه قوت تو هستند؛ حالا باید «پایان‌های حرفه‌ای» را هم به لیست توانمندی‌هایت اضافه کنی. پیگیری، ماندگاری و پاسخ‌گویی را در خودت تقویت کن.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. مدیریت هیجان و خشم را یاد بگیر</h3>
        <p className="text-gray-800 leading-7">
          از تمرین‌های تنفس، تأمل، توقف قبل از پاسخ‌دهی، و گفت‌وگو با افراد آرام‌تر برای مدیریت این بخش از شخصیتت استفاده کن.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. بین دیده شدن و اثربخش بودن تعادل برقرار کن</h3>
        <p className="text-gray-800 leading-7">
          همیشه لازم نیست توی چشم باشی تا مؤثر باشی. گاهی «کار بی‌صدا» تأثیر بیشتری از نمایش بیرونی دارد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>9. در تیم‌سازی به تنوع تیپ‌ها توجه کن</h3>
        <p className="text-gray-800 leading-7">
          افراد High S  و High C  می‌توانند مکمل تو باشند؛ آن‌ها آرام، دقیق، ساختاریافته و تحلیلی‌اند. تیم متنوع = موفقیت پایدار.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>10. مراقب فرسودگی باش</h3>
        <p className="text-gray-800 leading-7">
          پرانرژی بودن خوب است، اما اگر بی‌برنامه و بدون استراحت باشد، به زودی خسته، بی‌انگیزه و حتی پرخاشگر می‌شوی. خواب، تفریح، و بازنگری دوره‌ای عملکرد را فراموش نکن.
        </p>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی:
          Whiplash شلاق، فیلمی که درباره مرز باریک بین بلندپروازی، سخت‌کوشی و فشار بیش‌ازحد بر خود و دیگران است.  High DI ها می‌توانند از این فیلم درس‌های مهمی بگیرند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          از شور تا شعورِ مدیریتی
          High DI ها برای موفق شدن در مسیر شغلی و زندگی شخصی خود، نیازی به ایجاد تغییر اساسی در تیپ رفتاری‌شان ندارند؛ بلکه باید یاد بگیرند با هوشمندی، انرژی‌شان را به‌درستی هدایت کنند. رمز موفقیت آن‌ها در «متعادل‌سازی سرعت، قدرت و اثرگذاری» است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تمرین تأمل در کنار عمل‌گرایی</h3>
        <p className="text-gray-800 leading-7">
          High DI ها با انگیزه زیاد حرکت می‌کنند، اما گاهی توقف کوتاه برای اندیشه و بازبینی مسیر، می‌تواند از هدررفت انرژی و تصمیمات اشتباه جلوگیری کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تبدیل شور به ساختار</h3>
        <p className="text-gray-800 leading-7">
          شور و حرارت فراوانی در وجود  High DI هست؛ اما اگر با یک چارچوب ذهنی، زمان‌بندی و ابزارهای بهره‌وری ترکیب نشود، به شلوغی بی‌نتیجه تبدیل می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. ایجاد تعادل بین «من» و «ما»</h3>
        <p className="text-gray-800 leading-7">
          تمایل به جلو افتادن، برنده شدن و دیده شدن، اگر بدون توجه به تیم و اطرافیان باشد، در نهایت باعث تنهایی در موفقیت می‌شود. High DI ها اگر یاد بگیرند موفقیت را با دیگران تقسیم کنند، هم ماندگار می‌شوند، هم محبوب.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. جدی گرفتن مهارت‌های نرم</h3>
        <p className="text-gray-800 leading-7">
          شنیدن، صبوری، توجه به احساسات دیگران، احترام به تفاوت‌ها و مهارت‌های ارتباطی کلیدی، مسیر پیشرفت را نرم‌تر و اثربخش‌تر می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تبدیل بازخورد به دارایی</h3>
        <p className="text-gray-800 leading-7">
          بازخورد گرفتن سخت است، به‌خصوص برای کسی که همیشه جلوتر از دیگران فکر می‌کند. اما اگر  High DI یاد بگیرد منتقدانش را هم بشنود، جهش واقعی را تجربه خواهد کرد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت در تیپ High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. ثبات در پیگیری و پایان کارها</h3>
        <p className="text-gray-800 leading-7">
          شروع قوی، امضای توست؛ اما «ادامه دادن تا نتیجه نهایی» امضای حرفه‌ای‌هاست. هرچه بیشتر پروژه‌های ناتمام را تمام کنی، اعتبارت دو برابر می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. ایجاد رابطه‌های بلندمدت، نه فقط موقعیتی</h3>
        <p className="text-gray-800 leading-7">
          برای موفقیت پایدار، به رابطه‌هایی نیاز داری که بر پایه اعتماد، احترام متقابل و وفاداری شکل گرفته باشد، نه فقط استفاده‌های مقطعی یا سطحی.
        </p>
        <p className="italic text-gray-700">
          "موفقیت واقعی، ترکیب جسارت High D ، جذابیت High I، تمرکز High C و صبوری  High S  است."
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ High DI"
      >
        <p className="text-gray-800 leading-7">
          تعادل بین شور، منطق، احساس و پایداری
          افراد  High DI در بخش‌های «تسلط» و «اثرگذاری» بسیار قوی هستند، اما اگر لایه‌های دیگر مانند C  تحلیل‌گری، S  پایداری و حتی I  با عمق بیشتر در آن‌ها تقویت نشود، ممکن است دچار تصمیم‌های سطحی، روابط ناپایدار یا فرسودگی سریع شوند.
          در این بخش یاد می‌گیریم چگونه با استفاده از واژگان، جملات کلیدی و فضاهای تمرینی سایر ابعاد رفتاری را متعادل کنیم.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تقویت لایه C  تفکر منطقی و جزئی‌نگری:</h3>
        <p className="text-gray-800 leading-7">
          واژگان پیشنهادی: «بیایید دقیق‌تر بررسی کنیم»«مهمه که جزئیات رو فراموش نکنیم»
          «تحلیل داده‌ها کمک‌مون می‌کنه تصمیم بهتری بگیریم»
        </p>
        <p className="text-gray-800 leading-7">
          جملات تمرینی: ما باید قبل از تصمیم‌گیری یک‌بار دیگر با دقت تحلیل کنیم.
          بررسی مجدد، ریسک تصمیم را کاهش می‌دهد. شاید بهتر باشد از چند زاویه به موضوع نگاه کنیم.
        </p>
        <p className="text-gray-800 leading-7">
          تکنیک کاربردی:
          قبل از هر تصمیم بزرگ، با یک نفر High C  یا CS  مشورت کرده و بررسی عددی یا منطقی موضوع را انجام بده.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تقویت لایه S  صبوری، پایداری، همدلی</h3>
        <p className="text-gray-800 leading-7">
          واژگان پیشنهادی: «صبور باشیم» «مداومت در کار مهمه» «نظر دیگران هم مهمه، بذار بشنویمشون»
        </p>
        <p className="text-gray-800 leading-7">
          جملات تمرینی: گاهی بهتره آهسته‌تر ولی مطمئن‌تر حرکت کنیم.
          گوش دادن به دیگران به ما زاویه‌های تازه‌ای می‌ده. موفقیت پایدار از پیگیری منظم حاصل می‌شه.
        </p>
        <p className="text-gray-800 leading-7">
          تکنیک کاربردی: در جلسات، تا ۳۰ ثانیه اول فقط گوش بده و بعد شروع به صحبت کن. این تمرین قدرت صبر و شنیدن را تقویت می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تعدیل لایه I از محبوبیت سطحی تا نفوذ پایدار:</h3>
        <p className="text-gray-800 leading-7">
          واژگان پیشنهادی: «ارتباطات عمیق» «اعتمادسازی» «رابطه دوطرفه و ماندگار»
        </p>
        <p className="text-gray-800 leading-7">
          جملات تمرینی: محبوب بودن خوبه، اما ماندگار بودن بهتره. کاری کنیم که مردم حس واقعی اعتماد به ما داشته باشن. بزنیم به دل رابطه، نه فقط نمایش بیرونی اون.
        </p>
        <p className="text-gray-800 leading-7">
          تکنیک کاربردی: هفته‌ای یک‌بار از یک همکار یا دوست نزدیک بپرس: «به نظرت من کجا می‌تونم بهتر شنونده باشم؟» و یادداشت کن.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نتیجه‌گیری:"
      >
        <p className="text-gray-800 leading-7">
          High DI بودن یعنی «جلو بودن»، اما برای اینکه جلو بمانی و دیگران هم با تو همراه شوند، باید در خودت تعادل بسازی. ترکیب جسارت، جذابیت، تحلیل و پایداری همان چیزی است که از تو یک رهبر واقعی می‌سازد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی High DI"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری  High DI به‌طور طبیعی رهبر، پیش‌برنده، متقاعدکننده و جسور هستند. اما برای اینکه این ویژگی‌ها به نتیجه‌ مطلوب برسد و دیگران را نیز با خود همراه کنند، نیاز به تقویت برخی دانش‌ها و مهارت‌ها دارند. این بخش دقیقاً برای این طراحی شده تا High DIها بدانند روی چه مهارت‌هایی باید تمرکز کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. مهارت‌های تحلیلی و تصمیم‌گیری منطقی تقویت بعد C :</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>آموزش ابزارهای تحلیل داده مثل Excel، Power BI </li>
          <li>شناخت چارچوب‌های تصمیم‌گیری (مثل مدل SWOT، ماتریس آیزنهاور)</li>
          <li>مهارت‌های حل مسئله با تفکر سیستمی Systems Thinking</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. مهارت‌های گوش دادن فعال و همدلی تقویت بعد S :</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>یادگیری اصول «گوش دادن فعال»  Active Listening</li>
          <li>تمرین تکنیک‌های بازخورد سازنده و همدلانه</li>
          <li>مطالعه زبان بدن و پیام‌های غیرکلامی</li>
        </ul>
        <p className="text-gray-800 leading-7">
          پیشنهاد فیلم:
           The King's Speech  درباره شنیدن، اعتماد و رشد درونی
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. مهارت‌های مدیریت تیم و ارتباطات اثربخش تقویت رهبری سالم:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>اصول تیم‌سازی و انگیزش اعضای تیم Motivation Theory</li>
          <li>یادگیری شیوه‌های تفویض اختیار مؤثر و رهبری موقعیتی Situational Leadership</li>
          <li>توسعه ارتباطات بین‌فردی در سطوح سازمانی</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. مدیریت هیجان و خودکنترلی (برای جلوگیری از افراط رفتاری):</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تمرین مهارت‌های ذهن‌آگاهی Mindfulness</li>
          <li>آشنایی با مدل‌های هوش هیجانی (مانند مدل دانیل گلمن)</li>
          <li>یادگیری کنترل تکانه در شرایط تنش</li>
        </ul>
        <p className="text-gray-800 leading-7">
          پیشنهاد فیلم:
          Inside Out درون و بیرون،  درک احساسات درونی و مدیریت آن‌ها
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۵. توسعه تفکر استراتژیک و دید کلان (برای اثرگذاری بیشتر):</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>یادگیری تحلیل‌های آینده‌پژوهانه Foresight</li>
          <li>درک پویایی‌های بازار و رقبا (مدل ۵ نیروی پورتر)</li>
          <li>برنامه‌ریزی استراتژیک و چابک</li>
        </ul>
        <p className="text-gray-800 leading-7">
          کتاب پیشنهادی:
           Strategy Safari   جنگل استراتژی، هنری مینتزبرگ
           Start with Why  با چرا شروع کنید، سایمون سینک
        </p>
        <p className="text-gray-800 leading-7">
          نتیجه‌گیری:
           High DI بودن یک قدرت ذاتی است، اما برای تبدیل شدن به رهبران اثرگذار، نیاز به ارتقاء مهارت‌هایی است که شما را از یک بازیگر پرشور به یک بازی‌ساز استراتژیک تبدیل کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی High DI"
      >
        <p className="text-gray-800 leading-7">
          ترکیب رهبری، تأثیرگذاری، سرعت، و بلندپروازی
          تیپ رفتاری  High DI به‌طور طبیعی مناسب مشاغلی است که نیاز به پویایی بالا، رهبری پروژه، تعامل زیاد با دیگران، سرعت در تصمیم‌گیری و هدف‌گرایی دارند. این تیپ در محیط‌های کاری چابک، استارتاپ‌ها، فروش، مدیریت و فضاهای رسانه‌ای بهترین عملکرد را دارد.
        </p>
        <p className="text-gray-800 leading-7">
          در ادامه، مشاغل پیشنهادی با شرح مختصر مرتبط با ویژگی‌های رفتاری  High DI ارائه می‌شود:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. مدیر توسعه کسب‌وکار Business Development Manager</h3>
        <p className="text-gray-800 leading-7">
          موقعیت مناسب برای ترکیب جسارت، ارتباط‌سازی و شکار فرصت‌ها.  High DI در این شغل می‌تواند با شور زیاد، بازارهای جدیدی کشف و تیم‌های هم‌راستا ایجاد کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. سخنران انگیزشی / مدرس</h3>
        <p className="text-gray-800 leading-7">
          High DI ها عاشق تأثیرگذاری‌اند. اگر این انرژی در قالب آموزش یا الهام‌بخشی هدفمند شود، می‌تواند نتایج بزرگی داشته باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. مدیر فروش</h3>
        <p className="text-gray-800 leading-7">
          ترکیب "تسلط برای بستن قرارداد" و "اثرگذاری برای اقناع مشتری" دقیقاً همان چیزی است که این تیپ نیاز دارد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. کارآفرین / مؤسس استارتاپ</h3>
        <p className="text-gray-800 leading-7">
          نیاز به سرعت، تصمیم‌گیری سریع، شجاعت در مواجهه با ریسک، و جلب سرمایه‌گذار – همه از نقاط قوت  High DI است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. مدیر روابط عمومی یا برندینگ شخصی</h3>
        <p className="text-gray-800 leading-7">
          در این شغل، توانایی جلب توجه، محبوب‌سازی برند، و تعامل با ذی‌نفعان حیاتی است – چیزی که  High DI با آن زندگی می‌کند!
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. مجری یا میزبان برنامه‌های گفتگو محور</h3>
        <p className="text-gray-800 leading-7">
          اگر عاشق دیده شدن و صحبت کردن هستید، این فضا را از آنِ خودتان کنید!
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. مدیر بازاریابی یا مدیر برند</h3>
        <p className="text-gray-800 leading-7">
          در این نقش، خلاقیت، سرعت در اجرا، و توانایی رهبری کمپین‌های هیجان‌انگیز بسیار مهم است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. مشاور مدیریت / استراتژی</h3>
        <p className="text-gray-800 leading-7">
          High DI ها به خوبی می‌توانند سازمان‌ها را متحول کنند، مخصوصاً وقتی با اعتمادبه‌نفس بالا، مدل ذهنی تغییر را تزریق می‌کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>9. مدیر منابع انسانی (در نقش رهبری تحول)</h3>
        <p className="text-gray-800 leading-7">
          اگرچه مدیریت منابع انسانی برای  High DI چالش‌برانگیز است، ولی اگر در نقش «رهبر تحول منابع انسانی» باشد، می‌توانند تأثیرگذار باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>10. مدیر پروژه در شرکت‌های چابک Agile Project Leader</h3>
        <p className="text-gray-800 leading-7">
          توانایی تصمیم‌گیری سریع، انگیزش تیم، و حرکت در شرایط پرریسک – این موقعیت با ذات  High DI  سازگار است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="همسر داری و فرزند پروری الگوی رفتاری High DI"
      >
        <p className="text-gray-800 leading-7">
          High DI ها افرادی پرانرژی، بلندپرواز، اهل ریسک و برون‌گرا هستند. آن‌ها همزمان دو بُعد مهم را در شخصیت خود ترکیب کرده‌اند:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>D (Dominance) :  سلطه‌جو، هدف‌گرا، سریع‌تصمیم، نتیجه‌محور.</li>
          <li>I (Influence) :  اجتماعی، خوش‌صحبت، بااعتماد به نفس، تأثیرگذار.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          در روابط عاطفی، این افراد به دنبال هیجان، پیشرفت، دیده‌شدن و تأثیرگذاری هستند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. هوش هیجانی بالا</h3>
        <p className="text-gray-800 leading-7">
          توانایی درک و مدیریت احساسات خود و دیگران برای تعامل با فردی پرشور و گاهی انفجاری مثل High DI، بسیار حیاتی است.  High DI ممکن است گاهی با شدت یا عجله تصمیم بگیرد؛ داشتن یک همسر متعادل‌کننده، رابطه را تثبیت می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. قاطعیت و اعتماد به نفس</h3>
        <p className="text-gray-800 leading-7">
           High DI برای افرادی که خود را دست‌کم می‌گیرند یا همیشه منتظر هدایت بیرونی‌اند، جذابیتی ندارد. همسر او باید توان ایستادن پای نظراتش را داشته باشد، البته با لحن محترمانه و تعامل‌محور.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. روحیه حمایتگر بدون سلطه‌پذیری</h3>
        <p className="text-gray-800 leading-7">
          کسی که بتواند در پشت صحنه پشتیبان DI  باشد، بدون آنکه احساس ضعف یا باج‌دهی کند.  High DI قدردان حمایت است، به شرطی که این حمایت، هوشمندانه و غیرمحتاجانه باشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های شخصیتی مناسب همسر فرد High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. انعطاف‌پذیری و قدرت تطبیق بالا</h3>
        <p className="text-gray-800 leading-7">
          همراهی با فردی که دائم در حال هدف‌گذاری و اقدام است، نیازمند روحیه‌ای است که به‌سرعت خود را با شرایط جدید وفق دهد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. شخصیت عمل‌گرا و آینده‌نگر</h3>
        <p className="text-gray-800 leading-7">
          کسانی که اهل برنامه، اقدام، و رشدند، برای  High DI شریک خوبی هستند. افراد منفعل یا بیش‌ازحد محافظه‌کار به‌راحتی از دایره ارتباطی DI High  حذف می‌شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. خودباور و مستقل:</h3>
        <p className="text-gray-800 leading-7">
          فردی که بتواند بدون نیاز دائمی به تأیید یا وابستگی، از خودش مراقبت کند و تصمیم‌گیری کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. پذیرای انرژی و سرعت بالا:</h3>
        <p className="text-gray-800 leading-7">
          کسی که از زندگی پرشتاب و فعال لذت ببرد و بتواند پا به پای  High DI پیش بیاید یا حداقل با آن مخالفت نکند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. دارای روحیه رشد و جاه‌طلبی:</h3>
        <p className="text-gray-800 leading-7">
          High DIها نمی‌توانند با افرادی که بی‌هدف یا کند هستند زندگی موفقی داشته باشند. آن‌ها نیاز به همراهی با کسی دارند که خودش نیز مسیر پیشرفت را جدی گرفته باشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های شخصیتی مناسب همسر فرد High DI"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>9. توانایی مدیریت احساسات و تعادل عاطفی:</h3>
        <p className="text-gray-800 leading-7">
          چون  High DI ممکن است در لحظاتی شدید یا پرتلاطم شوند، همسر آن‌ها باید بتواند تعادل عاطفی محیط را حفظ کند، نه اینکه خودش نیز نوسان‌پذیر باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>10. اهل گفت‌وگو، اما با زبان کوتاه، قاطع و هدفمند:</h3>
        <p className="text-gray-800 leading-7">
          پرحرفی‌های بی‌نتیجه یا غر زدن‌های مداوم برای High DI  خسته‌کننده است. کسی که بتواند در زمان مناسب، واضح و محترمانه حرفش را بزند، بسیار جذاب‌تر خواهد بود.
        </p>
        <p className="text-gray-800 leading-7">
          مثال سینمایی (برای درک بهتر):
          شخصیت "میراندا پریسلی" در فیلم The Devil Wears Prada شیطان پرادا می‌پوشد، یک نمونه زنانه با تیپ High DI
          شخصیت "تونی استارک" در Iron Man  مرد آهنی، نیز نمونه‌ای از High DI  مردانه است.
        </p>
        <p className="text-gray-800 leading-7">
          همسر مناسب برای چنین افرادی باید ترکیبی از ثبات، قدرت و هوشمندی عاطفی باشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه ارتباط مؤثر با فرد High DI به‌عنوان همسر:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>به او فضا بدهید تا خودش را ابراز کند.</li>
          <li>او را بابت دستاوردها و ویژگی‌های منحصربه‌فردش تحسین کنید.</li>
          <li>در تصمیم‌گیری‌ها با او مشورت کنید اما اجازه بدهید گاهی مسئولیت کامل را بپذیرد.</li>
          <li>از سرزنش مستقیم یا برخوردهای احساسی شدید پرهیز کنید.</li>
          <li>تلاش کنید در تعاملات، مؤثر، قاطع و محترم باشید.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که همسر فرد High DI باید بداند"
      >
        <p className="text-gray-800 leading-7">
          همسر یک فرد  High DI اگر به این نکات آگاه باشد، می‌تواند رابطه‌ای سالم، پویا و پرانرژی را حفظ کند:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. به استقلال و رهبری او احترام بگذارید</h3>
        <p className="text-gray-800 leading-7">
          فرد High DI  عاشق استقلال، قدرت تصمیم‌گیری و رهبری است. اگر حس کند که آزادی عملش در رابطه محدود می‌شود، به سرعت دچار نارضایتی و فاصله‌گیری خواهد شد.
        </p>
        <p className="text-gray-800 leading-7">
          مثال: اگر  High DI تصمیمی در مورد یک سفر یا پروژه می‌گیرد، به جای مخالفت مستقیم، می‌توان پیشنهادهایی برای بهتر شدن آن ارائه کرد. «به نظرم کارت عالیه، فقط شاید فلان موضوع رو هم در نظر بگیریم» راه ارتباطی مؤثرتری از مخالفت مستقیم است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. او را بابت عملکرد و دستاوردهایش تحسین کنید</h3>
        <p className="text-gray-800 leading-7">
          High DI  ‌ها به شدت نتیجه‌گرا هستند و اگر از دستاوردشان تقدیر نشود، دچار سرخوردگی پنهان می‌شوند. تحسین صادقانه برایشان مثل سوخت موشک است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. در برابر هیجانات لحظه‌ای او واکنش هیجانی نشان ندهید</h3>
        <p className="text-gray-800 leading-7">
           High DI ممکن است گاهی پرخاشگر یا بسیار هیجان‌زده به نظر برسد. اگر شریک زندگی هم هیجانی شود، فضا متشنج خواهد شد. بهترین راه، آرام و منطقی ماندن در برابر موج هیجان اوست.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. درگیری‌های کوچک را شخصی نکنید</h3>
        <p className="text-gray-800 leading-7">
          High DI  گاهی با لحن تند چیزی می‌گوید، اما خیلی سریع فراموش می‌کند. اگر شما آن را در ذهن‌تان نگه دارید و از او دلگیر شوید، یک شکاف احساسی پدید می‌آید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. به او چالش بدهید، اما جنگ نکنید</h3>
        <p className="text-gray-800 leading-7">
          High DI  از چالش استقبال می‌کند، اما اگر حس کند مورد تهدید یا تخریب قرار گرفته، مقابله‌به‌مثل خواهد کرد. پس باهوشانه چالش ایجاد کنید، نه تقابل.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که همسر فرد High DI باید بداند"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. به او فضا بدهید</h3>
        <p className="text-gray-800 leading-7">
          هرچه High DI  بیشتر احساس کنترل داشته باشد، وفادارتر، عمیق‌تر و عاشق‌تر است. محدودیت‌های زیاد یا کنترل بیش‌ازحد، او را از رابطه خارج می‌کند.
        </p>
        <p className="text-gray-800 leading-7">
          پیشنهاد فیلم یا سریال برای درک بهتر رفتار High DI  در روابط:
          سریال Suits کت شلواری ها، شخصیت هاروی اسپکتر
          شخصیتی قوی، باهوش، رهبر، و در عین حال با لایه‌هایی عاطفی که نیاز به درک دارند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند:"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری  High DI اگر می‌خواهند روابط زناشویی موفقی داشته باشند، باید نسبت به برخی ویژگی‌های خود آگاه بوده و آن‌ها را مدیریت کنند. در ادامه، توصیه‌هایی کاربردی برای این افراد آمده است:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. به شریک زندگی خود گوش بدهید، نه فقط پاسخ بدهید</h3>
        <p className="text-gray-800 leading-7">
          High DI  ‌ها معمولاً سریع تصمیم می‌گیرند و در گفتگو دنبال نتیجه‌اند. اما در رابطه عاطفی، «شنیده‌شدن» مهم‌تر از «حل مسئله» است. یاد بگیرید گاهی فقط شنونده باشید و در میانه حرف همسرتان وارد نشوید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. به احساسات، همان‌قدر توجه کنید که به منطق توجه دارید</h3>
        <p className="text-gray-800 leading-7">
          در روابط زناشویی فقط تحلیل منطقی کافی نیست. همسر شما ممکن است به خاطر احساسی که تجربه کرده ناراحت باشد، نه فقط به خاطر «دلیلِ» آن. کمی هم با دل گوش بدهید، نه فقط با عقل.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. کنترل‌گری را کنار بگذارید و قدرت را شریک شوید</h3>
        <p className="text-gray-800 leading-7">
          گرایش به تسلط و رهبری ممکن است باعث شود تصمیم‌گیری‌های مهم را یک‌طرفه انجام دهید. بهتر است با همسرتان مشارکت کنید و به او نیز فضا دهید که اثرگذار باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. به لحن خود توجه کنید</h3>
        <p className="text-gray-800 leading-7">
          حتی اگر نیت‌تان خوب باشد، لحن خشک یا دستوری می‌تواند همسرتان را برنجاند. گاهی یک جمله با تغییر لحن، به جای برخورد، محبت‌آمیز به نظر می‌رسد.
        </p>
        <p className="text-gray-800 leading-7">
          مثال:
          به جای "این کارو باید انجام بدی"، بگویید:
          "به نظرم اگه این کارو انجام بدیم، نتیجه بهتری می‌گیریم."
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. سریع از اختلافات عبور نکنید</h3>
        <p className="text-gray-800 leading-7">
          High DI  ها دوست دارند مسائل را حل و تمام کنند، اما شریک زندگی ممکن است هنوز درگیر احساساتش باشد. بهتر است درک کنید که زمان احساسیِ طرف مقابل با شما یکسان نیست و باید صبر داشته باشید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. پذیرفتن اشتباه، نقطه ضعف نیست؛ نقطه قدرت است</h3>
        <p className="text-gray-800 leading-7">
          شاید برایتان سخت باشد که اشتباه خود را بپذیرید، اما باور کنید گاهی "متاسفم" گفتن، نشانه بالغانه‌ترین شکل رهبری در رابطه است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. توجه روزمره را فراموش نکنید</h3>
        <p className="text-gray-800 leading-7">
          ممکن است بسیار مشغول کار و اهداف باشید، اما توجه‌های کوچک روزمره (پیام محبت‌آمیز، یک جمله مثبت، تماس بی‌دلیل) برای پایداری رابطه بسیار حیاتی است.
        </p>
        <p className="text-gray-800 leading-7">
          تمرین پیشنهادی برای High DI ها:
          هر شب قبل از خواب، یک ویژگی مثبت همسرتان را یادداشت کنید یا در ذهن مرور کنید. این تمرین کمک می‌کند تمرکزتان از کنترل و عملکرد صرف، به قدرشناسی و حضور عاطفی منتقل شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین High DI با فرزندان و بالعکس"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری  High DI که والدین هستند، معمولاً والدینی پرتوقع، نتیجه‌گرا، و با استانداردهای بالا محسوب می‌شوند. این ویژگی‌ها اگر به درستی مدیریت نشوند، می‌توانند فشار زیادی به فرزندان وارد کنند. در ادامه راهکارهایی برای بهبود ارتباط والد-فرزندی برای این تیپ رفتاری ارائه می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. فرزندان شما انسان‌اند، نه پروژه‌ی اجرایی!</h3>
        <p className="text-gray-800 leading-7">
          High DI ها معمولاً عادت دارند با سرعت و هدف‌محوری بالا حرکت کنند و از اطرافیان نیز همین انتظار را دارند. اما فرزندان به ویژه در سنین پایین، بیش از آنکه نیازمند «دستاورد» باشند، نیاز به «احساس امنیت» و «دوست‌داشتنی‌بودن بی‌قید و شرط» دارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دستور ندهید، مشارکت دهید</h3>
        <p className="text-gray-800 leading-7">
          والدین High DI  تمایل دارند با فرزندان خود مانند یک مدیر با کارمند صحبت کنند. بهتر است لحن را دوستانه‌تر و کلمات را نرم‌تر انتخاب کنید. مثلاً به جای گفتن:
        </p>
        <p className="text-gray-800 leading-7">
          "کتابتو بردار و بخون!"
          بگویید:
          "می‌خوای با هم یه برنامه بچینیم که هم بازی کنی، هم مطالعه‌ات انجام بشه؟"
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. انتقاد بیش از حد، روحیه فرزند را فرسوده می‌کند</h3>
        <p className="text-gray-800 leading-7">
          توجه کنید که تأکید دائمی بر نقاط ضعف یا اشتباهات، باعث کاهش اعتماد به نفس و گاه سرکشی در فرزندتان می‌شود. اگر فرزندتان کاری را خوب انجام داد، آن را ببینید و بازخورد مثبت بدهید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. وقتی فرزند شما از شما می‌ترسد، دیگر با شما صادق نخواهد بود</h3>
        <p className="text-gray-800 leading-7">
          گاهی High DI ها به خاطر لحن قاطع و جدی، ناخواسته در فرزندان ترس ایجاد می‌کنند. این باعث می‌شود کودک احساس امنیت روانی برای صحبت درباره اشتباهات یا نگرانی‌هایش نداشته باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. به علایق فرزندتان احترام بگذارید، حتی اگر به نظر شما بی‌اهمیت است</h3>
        <p className="text-gray-800 leading-7">
          ممکن است فرزندتان به موسیقی، بازی، نقاشی یا حتی موضوعات عجیب علاقه‌مند باشد. قضاوت نکنید. پرسشگر باشید، نه طردکننده.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین High DI با فرزندان و بالعکس"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. بپذیرید که فرزند شما ممکن است تیپ رفتاری کاملاً متفاوتی با شما داشته باشد</h3>
        <p className="text-gray-800 leading-7">
          اگر فرزند شما یک High S  یا  High C  است، نیاز به امنیت، آرامش، و تأمل دارد. سرعت و فشار شما ممکن است برای او استرس‌زا باشد. از تفاوت‌های شخصیتی آگاه باشید و سازگارانه رفتار کنید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. زمان با کیفیت = ارتباط عمیق‌تر</h3>
        <p className="text-gray-800 leading-7">
          صرفاً حضور فیزیکی کافی نیست. سعی کنید زمان‌هایی کوتاه اما پر کیفیت با فرزندتان بگذرانید: بازی، گفت‌وگو، داستان‌گویی یا تماشای فیلم.
        </p>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی برای والدین High DI :
          "The Pursuit of Happyness"  در جست‌وجوی خوشبختی با بازی ویل اسمیت.
          این فیلم نمونه‌ای عالی از تعادل میان مسئولیت‌پذیری، هدف‌محوری و عشق پدرانه در مواجهه با فرزند است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد High DI ارتباط مؤثر برقرار کنیم؟"
      >
        <p className="text-gray-800 leading-7">
          اگر پدر یا مادر شما الگوی رفتاری  High DI دارند، یعنی شخصیتی ترکیبی از تسلط‌طلبی D  و برون‌گرایی تأثیرگذار I ، پس احتمالاً با شخصی سر و کار دارید که سریع، هدف‌گرا، پرانرژی، و در عین حال، دارای کاریزما و نیازمند دیده‌شدن است. برای داشتن ارتباط مؤثر با چنین والدی، نکات زیر می‌تواند بسیار کاربردی باشد:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. مستقیم، شفاف و خلاصه صحبت کنید</h3>
        <p className="text-gray-800 leading-7">
          والد  High DI حوصله‌ی توضیح‌های طولانی و غیرضروری ندارد. اگر می‌خواهید موضوعی را مطرح کنید، مستقیم بروید سر اصل مطلب؛ اما با احترام و لحنی قاطع.
        </p>
        <p className="text-gray-800 leading-7">
          مثال:
          به جای اینکه بگویید: "می‌دونی، امروز خیلی سخت بود، معلممون یه پروژه داد که واقعاً پیچیده بود، بعدش هم... "
          بگویید: "یه پروژه سخت داریم، می‌خوام باهات مشورت کنم چطور انجامش بدم."
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. از موفقیت‌های خودتان برای جلب توجه استفاده کنید</h3>
        <p className="text-gray-800 leading-7">
          والدین  High DI عاشق موفقیت‌اند. اگر کاری را خوب انجام دادید، آن را با افتخار به اشتراک بگذارید. آن‌ها به این سبک ارتباطی پاسخ مثبت می‌دهند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال:
          "رتبه اول کلاس شدم. فکر کردم دوست داری بدونی!"
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. ترس از واکنش آن‌ها باعث پنهان‌کاری نشود</h3>
        <p className="text-gray-800 leading-7">
          گاهی High DI ها واکنش‌های شدید دارند. اما پنهان‌کاری تنها باعث فاصله گرفتن و بی‌اعتمادی بیشتر می‌شود. صداقت شما باعث جلب احترامشان خواهد شد، حتی اگر ابتدا ناراحت شوند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد High DI ارتباط مؤثر برقرار کنیم؟"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. در گفتگوها از چارچوب «راه‌حل محور» استفاده کنید</h3>
        <p className="text-gray-800 leading-7">
          به‌جای فقط گفتن مشکل، همیشه پیشنهاد یا راه‌حل هم ارائه دهید. این باعث می‌شود والد      High DI  احساس کند با فردی مستقل و بالغ طرف است.
        </p>
        <p className="text-gray-800 leading-7">
          مثال:
          "تو امتحان ضعیف شدم، ولی با فلانی قرار گذاشتم تمرین کنیم و نمره‌ام رو جبران کنم."
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. اجازه بدهید احساس قدرت کنند، ولی استقلال خودتان را نیز نشان دهید</h3>
        <p className="text-gray-800 leading-7">
          اگر بخواهید تمام‌قد در برابرشان بایستید یا صرفاً مطیع باشید، هر دو حالت باعث تنش می‌شود. بهترین راه، برقراری تعادل است:
          با قدرت صحبت کنید، اما محترمانه.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. درگیری را به چالش تبدیل کنید</h3>
        <p className="text-gray-800 leading-7">
          والدین High DI  عاشق چالش‌اند. اگر اختلاف نظری وجود دارد، آن را به‌جای دعوا، به بحثی چالشی و قابل مذاکره تبدیل کنید. این مدل را دوست دارند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال:
          "بیا شرط ببندیم اگر تونستم تا دو هفته این کار رو انجام بدم، اجازه می‌دی اون برنامه‌ای که دوست دارم رو پیگیری کنم."
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد High DI ارتباط مؤثر برقرار کنیم؟"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. الگو قرار دادن آن‌ها، پل ارتباطی قوی‌تری می‌سازد</h3>
        <p className="text-gray-800 leading-7">
          بگویید:
          "دوست دارم مثل تو جدی و پیگیر باشم."
          این جمله ممکن است ساده به نظر برسد، اما برای یک High DI  ارزشمند و الهام‌بخش است.
        </p>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی برای فرزندان والد High DI :
          "Dead Poets Society"  انجمن شاعران مرده
          این فیلم قدرت رابطه‌ای الهام‌بخش بین معلم/والد و فرزند را با الگوی فردی اثرگذار، هدف‌گرا و آزاداندیش نشان می‌دهد.
        </p>
      </Page>
    </>
  )
}

export default HighDI
